var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),(_vm.renderGanttComponente)?_c('GanttComponente',{attrs:{"template":_vm.template,"codigoTemplate":_vm.codigoTemplate,"editarGantt":_vm.editar},on:{"cerrar":_vm.cerrarGantt}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }